/* ********************************************************************************* */
/*  This file contains string functions that may be useful on number of projects.    */
/* ********************************************************************************* */

// Function: getStrBetweenParens()
// Function that returns the string(s) between a set of open and close parethesis.
// Makes use of regex character class (which is the brackets) to match on everything 
// in the character class (pattern in braces). Note that because parens are special
// regex characters, they must be escaped.
export function getStrBetweenParens(stringValue)  {
    let startIndex = stringValue.indexOf('(') ;
    let endIndex   = stringValue.indexOf(')') ;
    let substrValue = stringValue.substr(startIndex, endIndex);
    let regexPattern = /[\(\)]/gi;  /* the bracket defines a character class */
    substrValue = substrValue.replace(regexPattern, '');
    return substrValue;
};

// Converts first character of a string to upppercase and the rest to lower case.
export function upperCaseFirst(stringValue)  {
    if (!stringValue || stringValue === '') return '';
    
    let firstCharacter   = stringValue.charAt(0);   // get first character
    let ucFirstCharacter = firstCharacter.charAt(0).toUpperCase();   // convert first character to upper case
    let restOfString     = stringValue.slice(1);
    let lcRestOfString   = restOfString.toLowerCase();
    return ucFirstCharacter + lcRestOfString;
};


// Converts the first character of all words in the string to upper case
export function ucFirstCharOfAllWords(str)  {
    var splitStr = str.toLowerCase().split(' ');
    for (var i = 0; i < splitStr.length; i++) {
        // You do not need to check if i is larger than splitStr length, as your for does that for you
        // Assign it back to the array
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
    }
    // Directly return the joined string
    return splitStr.join(' '); 
};


// Check if string has blank spaces. This results from user hitting space bar in input field
// Use this function 
export function isStringOfSpaceCharacters(stringValue)  {
    return stringValue.length > 0 && stringValue.trim() === '';
};

/*
 String function to check if input value is space characters.

  This function uses a regular expression that checks for a string
  that starts with 1 or more spaces, has no ascii characters in between, and
  ends with 0 or spaces.

  For regex refresher refer to javascript Regular Expressions google doc.

*/
export function isSpaceCharacters (stringValue)  {
    let spacePattern = /^\s+\w{0}\s*$/; 
    return spacePattern.test(stringValue);
};



// WEBPACK FOOTER //
// ./src/utils/strUtils.js